"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2372],{

/***/ 22372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ExpandableTileCases_ExpandableTileCases; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Picture/index.ts + 1 modules
var Picture = __webpack_require__(17856);
// EXTERNAL MODULE: ./src/components/Icon/index.ts + 2 modules
var Icon = __webpack_require__(68257);
;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/Card.tsx




const Card = (param)=>{
    let { handleActivateCard , item , isActive  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "expandableTile__card expandableTile__card--active",
        onClick: handleActivateCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    item.picture && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                        data: item.picture
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "expandableTile__card__header ".concat(!item.picture || !item.picture.publicUrl ? "expandableTile__card__header--biggerMargin" : ""),
                        children: item.header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "expandableTile__card__text",
                        dangerouslySetInnerHTML: {
                            __html: item.content
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "expandableTile__cardIcon",
                role: "button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    icon: isActive ? "UP_ARROW" : "DOWN_ARROW",
                    color: isActive ? "icon-orange" : "dark-grey",
                    width: "30"
                })
            }),
            isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "expandableTile__card__triangle"
            })
        ]
    });
};
/* harmony default export */ var components_Card = (Card);

;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/BottomItemMobile.tsx



const BottomItemMobile = (param)=>{
    let { closeBottomInfo , bottomInfo  } = param;
    return bottomInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "expandableTile__bottomItem",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: closeBottomInfo,
                className: "expandableTile__bottomItem__closeBtn",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "x"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "expandableTile__bottomItem__header ".concat(bottomInfo.pictureDown ? "expandableTile__bottomItem__header--smaller" : ""),
                children: bottomInfo.headerDown
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "expandableTile__bottomItem__info ".concat(bottomInfo.pictureDown ? "expandableTile__bottomItem__info--smaller" : ""),
                dangerouslySetInnerHTML: {
                    __html: bottomInfo.contentDown
                }
            }),
            bottomInfo.pictureDown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                data: bottomInfo.pictureDown,
                className: "expandableTile__bottomItem__img"
            })
        ]
    });
};
/* harmony default export */ var components_BottomItemMobile = (BottomItemMobile);

;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/MobileItem.tsx




const MobileItem = (param)=>{
    let { item , activeItem , handleActivateCard , closeBottomInfo  } = param;
    const cardRef = (0,react.useRef)(null);
    const bottomInfoRef = (0,react.useRef)(null);
    const isActive = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.content) === item.content;
    const handleActiveCard = ()=>{
        handleActivateCard();
        setTimeout(()=>{
            var _bottomInfoRef_current;
            return (_bottomInfoRef_current = bottomInfoRef.current) === null || _bottomInfoRef_current === void 0 ? void 0 : _bottomInfoRef_current.scrollIntoView({
                block: "center"
            });
        }, 200);
    };
    const handleCloseBottomInfo = ()=>{
        closeBottomInfo();
        setTimeout(()=>{
            var _cardRef_current;
            return (_cardRef_current = cardRef.current) === null || _cardRef_current === void 0 ? void 0 : _cardRef_current.scrollIntoView();
        }, 200);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "expandableTile__cardWrapper",
        ref: cardRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                item: item,
                isActive: isActive,
                handleActivateCard: handleActiveCard
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: bottomInfoRef,
                children: isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BottomItemMobile, {
                    closeBottomInfo: handleCloseBottomInfo,
                    bottomInfo: activeItem
                })
            })
        ]
    });
};
/* harmony default export */ var components_MobileItem = (MobileItem);

;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/ExpandableTileCasesMobile.tsx



const ExpandableTileCasesMobile = (param)=>{
    let { items  } = param;
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const handleActivateCard = (index)=>setActiveIndex(index);
    const closeBottomInfo = ()=>setActiveIndex(null);
    const activeItem = activeIndex !== null ? items[activeIndex] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileItem, {
                item: item,
                activeItem: activeItem,
                closeBottomInfo: closeBottomInfo,
                handleActivateCard: ()=>handleActivateCard(index)
            }, index))
    });
};
/* harmony default export */ var components_ExpandableTileCasesMobile = (ExpandableTileCasesMobile);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./utils/icons.tsx
var icons = __webpack_require__(42108);
;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/BottomItemDesktop.tsx




const BottomItemDesktop = (param)=>{
    let { bottomInfo , closeBottomInfo  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "downContent",
        children: bottomInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "section2",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "expandableTile__bottomItem desktop-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: closeBottomInfo,
                        className: "expandableTile__bottomItem__closeBtn",
                        children: icons/* closeIcon */.UF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "expandableTile__bottomItem__header textContent-lg",
                        children: bottomInfo.headerDown
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "expandableTile__bottomItem__info",
                        dangerouslySetInnerHTML: {
                            __html: bottomInfo.contentDown
                        }
                    }),
                    bottomInfo.pictureDown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                        data: bottomInfo.pictureDown,
                        className: "expandableTile__bottomItem__img"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_BottomItemDesktop = (BottomItemDesktop);

;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/DesktopCards.tsx




const DesktopCards = (param)=>{
    let { items  } = param;
    const [activeIndex, setActiveIndex] = (0,react.useState)(null);
    const cardsRef = (0,react.useRef)(null);
    const bottomInfoRef = (0,react.useRef)(null);
    const handleActivateCard = (index)=>{
        var _cardsRef_current;
        setActiveIndex(index);
        (_cardsRef_current = cardsRef.current) === null || _cardsRef_current === void 0 ? void 0 : _cardsRef_current.scrollIntoView();
    };
    const closeBottomInfo = ()=>{
        var _cardsRef_current;
        setActiveIndex(null);
        (_cardsRef_current = cardsRef.current) === null || _cardsRef_current === void 0 ? void 0 : _cardsRef_current.scrollIntoView();
    };
    const activeItem = activeIndex !== null ? items[activeIndex] : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "expandableTile__cardsDesktop",
                ref: cardsRef,
                children: items.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_Card, {
                        item: item,
                        isActive: index === activeIndex,
                        handleActivateCard: ()=>handleActivateCard(index)
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: bottomInfoRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BottomItemDesktop, {
                    closeBottomInfo: closeBottomInfo,
                    bottomInfo: activeItem
                })
            })
        ]
    });
};
/* harmony default export */ var components_DesktopCards = (DesktopCards);

;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/components/ExpandableTileCasesDesktop.tsx




const LINE_BREAK = 3;
const ExpandableTileCasesDesktop = (param)=>{
    let { items  } = param;
    const itemsGroups = (0,lodash.chunk)(items, LINE_BREAK);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: itemsGroups.map((group, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(components_DesktopCards, {
                items: group
            }, index))
    });
};
/* harmony default export */ var components_ExpandableTileCasesDesktop = (ExpandableTileCasesDesktop);

// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/ExpandableTileCases.tsx





const ExpandableTileCases = (param)=>{
    let { blockData  } = param;
    const { data: items , background  } = blockData;
    const containerClass = "expandableTile__container desktop-container paddingsForBlocks ".concat(background === "grey" ? "mainBackgroundGrey" : "", " ");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: containerClass,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
            query: "(max-width: 767px)",
            defaultMatches: true,
            children: (matches)=>matches ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExpandableTileCasesMobile, {
                    items: items
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExpandableTileCasesDesktop, {
                    items: items
                })
        })
    });
};
/* harmony default export */ var ExpandableTileCases_ExpandableTileCases = (ExpandableTileCases);

;// CONCATENATED MODULE: ./src/blocks/ExpandableTileCases/index.ts



/***/ })

}]);